import useGet from '../../../core/composables/api/useGet'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import type { SurveyAnalysis } from '@/core/models/surveys-analytics'

export const useSurveyAnalysis = () => {
  const route = useRoute()
  const templateId = route.params.surveyId as string

  const { data, status, load } = useGet<SurveyAnalysis>(`survey/${templateId}/analysis`)

  onMounted(() => {
    load()
  })

  return { data, status, load }
}
